// extracted by mini-css-extract-plugin
export default {"addDepartment":"AddBtn_addDepartment__g+xvO"};